import React, { useState } from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import UpdatePasswordModal from '../containers/Dashboard/Modals/UpdatePasswordModal';

import classes from './BobContextMenu.module.css';

const BobContextMenu = ({
    apiVersion,
    currentUser,
    ...props
}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [updatePasswordModalOpen, setUpdatePasswordModalOpen] = useState(false);

    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleSignOut = () => {
        props.history.push('/');

        props.signOut();
    };

    const handleUpdatePassword = () => {
        setUpdatePasswordModalOpen(!updatePasswordModalOpen);
    };

    return (
        <React.Fragment>
            <ClickAwayListener
                onClickAway={() => setMenuOpen(false)}
            >   
                { currentUser && currentUser.userName ?
                    <div className={classes.BobContextMenu}>
                        <Button
                            onClick={handleToggle}
                        >
                            <i className="fas fa-user" aria-hidden="true" />
                            { currentUser.userName }
                            <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                        </Button>
                        { 
                            menuOpen ?
                                <Paper className={classes.BobContextMenuContainer}>
                                    <h4>User Profile</h4>
                                    <div>
                                        <small>Email</small>
                                        <p>{ currentUser.email }</p>
                                    </div>
                                    <div>
                                        <small>Phone</small>
                                        <p>{ currentUser.phone }</p>
                                    </div>
                                    <hr />
                                    <div>
                                        <div style={{fontSize: '1.2rem'}}>Version: {apiVersion}</div>
                                    </div>
                                    <hr />
                                    <div>
                                        <Button
                                            onClick={handleUpdatePassword}
                                        >
                                            {'Update password'}
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            onClick={handleSignOut}
                                        >
                                            {'Sign out'}
                                        </Button>
                                    </div>
                                </Paper> :
                                null
                        }
                    </div> : <> </>
                }
            </ClickAwayListener>
            <React.Fragment>
                {
                    updatePasswordModalOpen ?
                        <UpdatePasswordModal
                            handleUpdatePassword={handleUpdatePassword}
                        />
                        :
                        null
                }
            </React.Fragment>
        </React.Fragment>
    );
};

BobContextMenu.defaultProps = {
    currentUser: {}
};

BobContextMenu.propTypes = {
    currentUser: object
};

const mapStateToProps = state => {
    return {
        apiVersion:  state.core.apiVersion,
        currentUser: state.currentUser
    };
};

export default withRouter(connect(mapStateToProps, null)(BobContextMenu));
